import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useWebhookCache } from './cache'
import {
  type WebhookData,
  type UnsavedWebhookData,
  toResponseError,
  type WebhookAddInput,
  type WebhookAddSuccess,
} from '@terros/common'

export function useAddWebhook(): AddHookResponse<UnsavedWebhookData, WebhookData> {
  const mutation = useTantalimMutation<WebhookAddInput, WebhookAddSuccess>({
    url: '/webhook/add',
  })
  const cache = useWebhookCache()

  async function add(unsaved: UnsavedWebhookData): Promise<WebhookData> {
    try {
      const { webhook } = await mutation.mutateAsync({ webhook: unsaved })
      cache.addItem(webhook)
      return webhook
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
